import { FC } from 'react';
import { useBrandLocaleValue } from '@/react/hooks/useBrandLocaleValue';
import { TevaContent } from './TevaContent';

/**
 * Allow to set default content per brand.
 */
export const NotFoundContent: FC = () => {
  const BrandContent = useBrandLocaleValue<FC>(
    () => ({ default: () => null }),
    []
  );
  return <BrandContent />;
};
